module.exports = "<div class=\"resource-item-content resource-reel-item\">\r\n    <h3>Select your jurisdictions</h3>    \r\n    <p>Before you begin, use the Settings menu to select one or more jurisdictions.</p>\r\n    <p>You can change your settings at any time.</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/overview-resource-select-jurisdiction.html
// module id = 384
// module chunks = 1